import React from 'react';
import './bukadonasi.css'

const Input = ({ label, ...rest }) => {
    return (
        <div className="input-wrapper">
            <p className="label-open-donation">{label}<span className="star-red">*</span></p>
            <input className="input-open-donation" {...rest} />
        </div>
    )
}
export default Input;